import type MailboxInfo from "./MailboxInfo";

/**
 * Specialization of the MailboxInfo type for unified inbox mailboxes, these mailboxes are used to show data from multiple accounts
 */
export interface UnifiedInboxMailboxInfo extends MailboxInfo {
    // The UnifiedInboxMailboxInfo type is a special mailbox that shows data from multiple accounts
    readonly type: "UnifiedInbox";
    
    // Must also be a UnifiedInbox
    readonly mailboxRank: "UnifiedInbox";
    
    // The mailbox infos of the accounts must be present
    readonly accountsMailboxInfos: MailboxInfo[];
}

/**
 * Predicate function to check if the mailboxInfo is a UnifiedInboxMailboxInfo
 */
export function isUnifiedInboxMailboxInfo(mailboxInfo: MailboxInfo | null | undefined): mailboxInfo is UnifiedInboxMailboxInfo {
    return (mailboxInfo?.type === "UnifiedInbox" &&
        mailboxInfo?.mailboxRank === "UnifiedInbox" &&
        !!(mailboxInfo as UnifiedInboxMailboxInfo)?.accountsMailboxInfos.every(mbxInfo => !!mbxInfo));
}
